<template>
  <div class="benefit-detail">
    <div class="close-dialog">
      <button class="btn btn-sm" @click="$emit('close')">
        <i class="fa-light fa-close"></i>
      </button>
    </div>
    <div class="product-image">
      <div
        class="img-cover"
        :style="`background-image: url(${product.picture})`"
      />
    </div>
    <div class="product-info">
      <h4 class="mb-3">{{ product.title }}</h4>
      <div class="price-info mb-4">
        <div v-if="product.promotion">
          <div class="original-price">
            De: <del>R$ {{ product.price }}</del>
          </div>
          <div class="promotion-price">
            Por: <strong>R$ {{ product.promotion }}</strong>
          </div>
          <div v-if="product.installments > 0" class="installments">
            Ou {{ product.installments }}x de R$
            {{ installmentsPricePromotion }}
          </div>
        </div>
        <div v-else>
          <div class="regular-price">
            <strong>R$ {{ product.price }}</strong>
          </div>
          <div v-if="product.installments > 0" class="installments">
            Ou {{ product.installments }}x de R$ {{ installmentsPrice }}
          </div>
        </div>
      </div>
      <div class="description mb-4" v-html="product.description"></div>
      <a class="btn btn-primary px-5 py-3" :href="product.url" target="_blank">
        Participar
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "benefit-details",
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    installmentsPricePromotion() {
      return (this.product.promotion / this.product.installments).toFixed(2);
    },
    installmentsPrice() {
      return (this.product.price / this.product.installments).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.benefit-detail {
  display: grid;
  grid-template-columns: 0.7fr 1fr;
  margin: 0;
  padding: 0;

  .product-image {
    height: 100%;
    margin: 0;
    padding: 0;
    .img-cover {
      width: 100%;
      height: 100%;
      background-color: rgba(10, 5, 15, 0.7);
      background-size: cover;
      background-position: center;
      margin: 0;
      border-radius: 8px 0 0 8px;
    }
  }

  .product-info {
    padding: 48px 24px 24px;

    h4 {
      font-feature-settings: "liga" off, "clig" off;
      font-size: 24px;
      font-style: normal;
      font-weight: 800;
      line-height: 120%;
      letter-spacing: 0.1px;
    }
    .original-price {
      background: linear-gradient(180deg, #00e6bc 0%, #00a396 100%);
      background-clip: text;
      -webkit-background-clip: text;
      color: #00a396;
      font-size: 14px;
    }

    .promotion-price {
      background: linear-gradient(180deg, #00e6bc 0%, #00a396 100%);
      font-size: 24px;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .regular-price {
      font-size: 1.2rem;
    }

    .installments {
      color: #666;
      font-size: 0.9rem;
    }

    .description {
      color: #666;
      line-height: 1.5;
      min-height: 350px;
      max-height: 350px;
      overflow-y: scroll;
      overflow-x: hidden;
      padding-right: 10px;

      &::-webkit-scrollbar {
        width: 8px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgb(76, 76, 76);
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
  }
}
</style>
